import * as React from 'react';
import Modal from 'src/components/common/Modal';
import ECheckForm from '../ECheckForm';

import { IInvoiceEcheck } from '../ECheckForm/ECheckForm';

interface IECheckModalDesktopProps {
  onCloseModal: () => void;
  invoices: IInvoiceEcheck[];
  userAccount: string;
}

const styles = {
  padding: 0,
  height: '100%',
  width: '100%'
};

class ECheckModalDesktop extends React.Component<
  IECheckModalDesktopProps,
  any
> {
  public render() {
    return (
      <Modal
        handleCloseModal={this.props.onCloseModal}
        showClose={false}
        styles={styles}
      >
        <ECheckForm
          handleCloseModal={this.props.onCloseModal}
          invoices={this.props.invoices}
          userAccount={this.props.userAccount}
          showTable={true}
        />
      </Modal>
    );
  }
}

export default ECheckModalDesktop;
